// Mirror of tailwind.config.js palette for recharts (Tailwind v3 emits no --color-* vars).
// If a theme/dark-mode switch lands later, promote these to CSS variables.
export const chartTokens = {
  primary: '#BB1F4F',
  accent: '#7C1234',
  ok: '#1F8A5B',
  warn: '#B17A0B',
  danger: '#C8362A',
  qr: '#1B3A8A',
  ink3: '#79766B',
  line: '#E3DFD6',
} as const;

/** Ordered palette for multi-series charts (bars/slices). */
export const chartSeries: string[] = [
  chartTokens.primary,
  chartTokens.qr,
  chartTokens.ok,
  chartTokens.warn,
  chartTokens.accent,
  chartTokens.ink3,
];

/** Shared chart heights so the lazy skeleton matches the loaded chart (no CLS). */
export const CHART_H = { sm: 200, md: 260 } as const;
